<template lang="pug">
  .smart-table
    //- TABLE HEADER
    table-header.mb-2(
      v-model="visibleHeaders"
      :headers="headers"
      @search="isSearch = !isSearch"
      @reset="resetSearch"
      :hasSearchFields="visibleHeaders.some(({searchable}) => searchable)"
      :search-keys="searchKeys"
    )
      slot(name="header")
    v-divider

    //- TABLE
    v-alert.ma-0(
      tile
      v-if="error"
      text
      type="error"
    ) {{ error }}
    template(v-else)
      v-simple-table(:loading="loading" :headers="visibleHeaders" hide-default-header)
        //- TABLE HEADERS
        thead.v-data-table-header
          tr
            th(v-if="showSelect" style="max-width: 20px !important; min-width: 0 !important;").dense
            th.sortable(
              v-for="(t, idx) in visibleHeaders"
              :key="idx"
              :class="{ pinned: t.pinned, dense: t.value === 'view', 'text--center': t.align === 'center' }"
              @click="t.sortable ? toggleSort(t.value) : ''"
            )
              slot(
                :name="`header--${t.value}`"
              )
                span.d-flex.align-center {{ visibleHeaders[idx].text }}
                  v-icon.order(
                    :class="{ desc: sort[t.value] && sort[t.value] === 'DESC', 'hidden': !(t.sortable && sort[t.value]) }"
                  ) mdi-chevron-down
          v-expand-transition
            tr(v-if="isSearch" key="search-fields")
              th(v-if="showSelect" style="min-width: 0 !important;")
              th.pa-2(
                v-for="(t, idx) in visibleHeaders"
                :key="t.value"
                :class="{ pinned: t.pinned }"
                :style="`height:auto; ${t.maxWidth ? `max-width: ${t.maxWidth} !important; min-width: 0 !important;` : ''} `"
              )
                slot(
                  v-if="visibleHeaders[idx].searchable"
                  :name="`search--${t.value}`"
                  v-bind="{ searchKeys, runSearch }"
                )
                  v-autocomplete(
                    v-if="t.value === 'question_category_name'"
                    prepend-inner-icon="mdi-magnify"
                    v-model="searchKeys[visibleHeaders[idx].value]"
                    :placeholder="visibleHeaders[idx].text"
                    outlined
                    :items="Object.values(cachedCategories)"
                    item-text="name"
                    item-value="name"
                    dense
                    hide-details
                    @input="runSearch"
                  )
                    v-autocomplete(
                    v-if="t.value === 'question_category_id'"
                    prepend-inner-icon="mdi-magnify"
                    v-model="searchKeys[visibleHeaders[idx].value]"
                    :placeholder="visibleHeaders[idx].text"
                    outlined
                    :items="Object.values(cachedCategories)"
                    item-text="name"
                    item-value="id"
                    dense
                    hide-details
                    @input="runSearch"
                  )
                  v-text-field(
                    v-else
                    :prepend-inner-icon="t.notVisibleIcon ? '' : 'mdi-magnify'"
                    v-model="searchKeys[visibleHeaders[idx].value]"
                    :placeholder="visibleHeaders[idx].text"
                    outlined
                    dense
                    hide-details
                    @input="runSearch"
                  )
        //- TABLE ITEMS
        tbody
          tr.v-data-table__empty-wrapper(v-if="loading")
            td(colspan="100%" style="height:5px;").pa-0
              v-progress-linear(:active="loading" indeterminate)
          tr(v-for="item in isLocalPagination ? localItems : items" v-bind="rowClass(item)")
            slot(name="row" v-bind:item="item")
              td(v-if="showSelect")
                v-checkbox(
                  :key="item.id"
                  v-model="selected"
                  :value="item.id"
                  hide-details
                  dense
                ).ma-0
              td(
                v-for="(t, idx) in visibleHeaders"
                :key="idx"
                :class="{ pinned: t.pinned }"
              )
                slot(
                  :name="`value--${t.value}`"
                  v-bind:item="item"
                )
                  template {{ item[t.value] }}
          tr(v-if="items.length === 0 && !loading")
            td(colspan="100%" style="height:5px;").pa-0
              .d-flex.flex-column.align-center
                empty-icon
                slot(name="empty")
                  .mb-4 {{ noDataText }}
      v-row.ma-0(v-if="isLocalPagination && items.length > 20")
        v-pagination(v-model="localPaginationCurrent" :length="localPaginationCount")
      //- TABLE PAGINATION
      v-divider
      TablePagination(
        v-if="pagination.total"
        :pagination.sync="pagination"
      )

      //- .v-data-footer.d-flex.align-center.px-0(v-if="pagination.total")
      //-   v-btn(
      //-     @click="pagination.page = 1"
      //-     :disabled="pagination.page <= 2"
      //-     text
      //-     fab
      //-     tile
      //-     small
      //-   )
      //-     v-icon mdi-chevron-double-left
      //-   v-btn(@click="pagination.page -= 1" :disabled="pagination.page === 1" text fab tile small)
      //-     v-icon mdi-chevron-left
      //-   v-btn(@click="pagination.page += 1" :disabled="pagination.page >= pagesCount" text fab tile small)
      //-     v-icon mdi-chevron-right
      //-   v-btn(
      //-     @click="pagination.page = pagination.pages"
      //-     :disabled="pagination.page >= pagesCount - 1"
      //-     text
      //-     fab
      //-     tile
      //-     small
      //-   )
      //-     v-icon mdi-chevron-double-right

      //-   p.caption.mb-0.mx-2.mr-auto
      //-     | {{ (pagination.page - 1) * pagination.perPage + 1 }} - {{ maxItemsCount }}
      //-     | из {{ pagination.total }}
      //-   .d-flex.align-center.v-data-footer__select.ma-0
      //-     p.caption.mb-0.mr-2 Количество строк:
      //-     v-select.ma-0.rounded-0(
      //-       filled
      //-       v-model="pagination.perPage"
      //-       :items="PER_PAGE_VALUES"
      //-       @change="pagination.page = 1; init();"
      //-       hide-details
      //-       dense
      //-     )

</template>

<script>
import { mapGetters } from 'vuex';
import TableHeader from './components/TableHeader.vue';
import EmptyIcon from './components/EmptyIcon.vue';
import { getPagination } from '@/lib/pagination';
import { PER_PAGE_VALUES } from './constants';
import TablePagination from './components/TablePagination.vue';

/*
* props:
* adapter            - функция(обязательная), принимает
                       { page<Номер старницы>, search<JSON поисковых ключей> },
                       должна вернуть Promise c результатом запроса
* prepareSearchKeys  - функция, принимает keys, должна вернуть подготовленный для поиска JSON объект,
                       по умолчанию преобразует JSON в вид [{ search[field]: value, search[field]: value ... }]
* headers            - заголовки таблицы в формате [{ text, value }, {text, value }]
* fixed              - таблица с типом fixed, относится к оформлению
* showSelect         - выделение элементов
*/

export default {
  name: 'SmartTable',
  components: { TableHeader,  EmptyIcon, TablePagination },
  props: {
    customOrder: { type: Function, required: false, default: null },
    adapter: { type: Function, required: true },
    headers: { type: Array, default: () => [] },
    fixed: { type: Boolean, default: false },
    needToUpdateTable: { type: Boolean, default: false },
    showSelect: { type: Boolean, default: false },
    value: { type:Array, required: false, default: () => ([]) },
    rowClass: { type: Function, required: false, default: () => ({}) },
    sorting: { type: Object, required: false, default: () => ({}) },
    storageSaveProject: { type: Boolean, required: false, default: false },
    isLocalPagination: { type: Boolean, required: false, default: false },
    isLocalFilter: { type: Boolean, required: false, default: false },
    noDataText: { type: String, default: 'Записи не найдены' },
  },
  data() {
    return {
      localPaginationCurrent: 1,
      isSearch:false,
      items: [],
      filteredItems: [],
      selected: [],
      visibleHeaders: [],
      error: '',
      loading: true,

      pagination: {
        pages: 1,
        perPage: PER_PAGE_VALUES[1].value,
        total: 0,
        page: 1,
      },
      sort:{},

      cache: {}, // PAGE SESSION CACHE

      searchKeys: {},
      PER_PAGE_VALUES,
    };
  },
  computed:{
    ...mapGetters({
      'cachedCategories': 'cache/cachedCategories',
    }),
    localItems() {
      return this.filteredItems.filter((item, idx) => idx <= this.localPaginationCurrent * 20 && idx >= ((this.localPaginationCurrent - 1) * 20));
    },
    localPaginationCount() {
      return Math.ceil(this.filteredItems.length / 20);
    },
    preparedSearchKeys() {
      const params = {};
      Object.keys(this.searchKeys).forEach((key) => {
        if (this.searchKeys[key]) {
          params[`search[${key}]`] = this.searchKeys[key];
        }
      });
      return params;
    },
    prepareOrder() {
      return this.customOrder ? this.customOrder(this.sort) : Object.keys(this.sort).reduce((acc, value) => {
        if (this.sort[value] === 'DESC') acc.sort = `${value}`;
        if (this.sort[value] === 'ASC') acc.sort = `-${value}`;
        return acc;
      }, {});
    },
  },
  watch: {
    needToUpdateTable(val) {
      if (!val) return;
      this.cache =  {};
      this.pagination.page = 1;
      this.init();
    },
    'pagination.page' :{
      handler(v, oldV) {
        if (v === oldV) return;
        this.init();
      },
    },
    'pagination.perPage' :{
      handler(v, oldV) {
        if (v === oldV) return;

        this.init();
      },
    },
    'sorting':{
      immediate: true,
      handler(v) {
        this.sort = v;
      },
    },
    selected() {
      this.$emit('input', this.selected);
    },
    value(v) {
      this.selected = v;
    },
  },

  created() {
    this.sort = this.sorting;
    if (this.storageSaveProject) this.getProject();
    this.init();
  },

  methods: {
    saveProject(val) {
      localStorage.setItem('project_id', JSON.stringify(val));
    },
    getProject() {
      this.isSearch = true;
      const result = localStorage.getItem('project_id');
      const resultdata = result === 'undefined' ? null : JSON.parse(result);
      this.searchKeys = {
        ...this.searchKeys,
        project_id:  resultdata,
      };
    },
    updateItems(callback) {
      const result = callback([...this.items]);
      this.items =  result || this.items;
      this.cache = {};
    },

    init() {
      const params = {
        ...this.preparedSearchKeys,
        ...this.prepareOrder,
        'page': this.pagination.page || 1,
        'per-page': this.pagination.perPage,
      };
      if (this.storageSaveProject) this.saveProject(this.searchKeys.project_id);
      const key = JSON.stringify(params);

      this.loading = true;
      this.error = '';
      if (this.cache[key]) this.items = this.cache[key].data.data;
      else {
        this.adapter(params).then(
          (response) => {
            this.items = response.data.data;
            this.filteredItems = response.data.data;
            this.pagination = { ...this.pagination, ...getPagination(response.headers) };
            this.$emit('updated', this.items);
            this.loading = false;
          },
        );
      }
      // try {
      //   if (this.cache[key]) response = this.cache[key];

      //   else response = this.adapter(params);

      //   this.items = response.data.data;
      //   this.pagination = { ...this.pagination, ...getPagination(response.headers) };
      //   // Дает доступ к items родилю
      //   this.$emit('updated', this.items);
      // } catch (error) {
      //   this.error = 'Произошла ошибка обратитесь к администратору';
      // } finally {
      //   this.loading = false;
      //   this.cache[key] = response;
      // }
    },

    toggleSort(value) {
      if (this.sort[value] === 'ASC') this.sort[value] = 'DESC';
      else if (this.sort[value] === 'DESC') delete this.sort[value];
      else this.sort[value] = 'ASC';
      this.sort = { [value]: this.sort[value] };
      this.pagination.page = 1;
      this.init();
    },

    runSearch() {
      if (this.isLocalFilter) {
        const searchKeyses = Object.keys(this.searchKeys);
        // const [value] = Object.values(this.searchKeys);
        this.filteredItems = this.items.filter((item) => {
          const result = searchKeyses.every((searchKey) => {
            if (this.searchKeys[searchKey] === '' || this.searchKeys[searchKey] === null) return true;
            let result1;
            if (searchKey.includes('id')) {
              result1 = +this.searchKeys[searchKey] === +item[searchKey];
              return result1;
            }
            result1 = item[searchKey].toString().includes(this.searchKeys[searchKey]);
            return result1;
          });
          return result;
        });
      } else {
        this.pagination.page = 1;
        this.init();
      }
    },

    resetSearch() {
      this.searchKeys = {};
      this.isSearch = false;
      this.init();
    },
  },
};
</script>

<style lang="scss">
.theme--dark {
  .smart-table {
    table {
      tr {
        .pinned {
          background-color: #1e1e1e;
        }
      }
    }
  }
}

.smart-table {
  table {
    tr {
      th {
        min-width: 100px !important;
        border-bottom: thin solid rgba(0, 0, 0, 0.12);

        &.dense {
          width: 20px !important;
          min-width: 20px !important;
        }

        .v-text-field {
          // min-width: 150px;
          font-weight: normal;
        }
      }
      th ~ .pinned,
      td ~ .pinned {
        border-left: 3px  solid rgba(0, 0, 0, 0.25);

      }
      .pinned {
        left: -2px;
        z-index: 1;
        position: sticky;
        top: auto;
        border-right: 3px  solid rgba(0, 0, 0, 0.25);
        background-color: white;
      }
    }
  }
  .order {
    transition: all 0.5s ;
    &.desc {
      transform: rotate(180deg);
    }
    &.hidden {
      opacity: 0;
    }
  }
}
</style>
